"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomMainTab2 = exports.MainTab3 = exports.MainTab2 = void 0;
var react_1 = __importStar(require("react"));
require("./index.less");
var react_router_dom_1 = require("react-router-dom");
var web_1 = require("../../../../config/web");
var sidemenu_1 = require("../../../../modules/data/sidemenu");
var inner_pathname = '/gridlist.html';
/**
 * 二级菜单内容Tab
 */
function MainTab2() {
    var _this = this;
    var _a = (0, react_1.useState)(null), config = _a[0], SetConfig = _a[1];
    var _b = (0, react_1.useState)([]), itemlist = _b[0], SetItemList = _b[1];
    var _c = (0, react_1.useState)(null), selectindex = _c[0], SetSelectIndex = _c[1];
    var location = (0, react_router_dom_1.useLocation)();
    /** 获取配置 */
    var getConfig = function () { return __awaiter(_this, void 0, void 0, function () {
        var config;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, sidemenu_1.getSidemenuData)()];
                case 1:
                    config = _a.sent();
                    SetConfig(config.sidemenu);
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        getConfig();
    }, []);
    (0, react_1.useEffect)(function () {
        if (config) {
            var pathname = location.pathname.replace(/^\/center\//, "/").replace(/^\/center2\//, "/");
            var pathway = findPath(config, pathname, location.hash);
            if (pathway.length > 1) {
                SetItemList(config[pathway[0]].sub);
                SetSelectIndex(pathway[1]);
            }
        }
    }, [config, location]);
    if (config == null)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement("div", { className: "maintab" },
        react_1.default.createElement("ul", { className: "scf" }, itemlist.map(function (v, index) {
            return react_1.default.createElement(react_1.default.Fragment, { key: index }, v.path ?
                react_1.default.createElement("li", { className: index == selectindex ? 'active' : '' },
                    react_1.default.createElement(react_router_dom_1.Link, { to: web_1.routerPrefix + (v.path.indexOf('#') == 0 ? inner_pathname : '') + v.path }, v.title))
                :
                    react_1.default.createElement("li", null,
                        react_1.default.createElement("a", { href: v.link }, v.title)));
        }))));
}
exports.MainTab2 = MainTab2;
/**
 * 三级菜单内容Tab
 */
function MainTab3(props) {
    var _this = this;
    var _a;
    var _b = (0, react_1.useState)(null), config = _b[0], SetConfig = _b[1];
    var _c = (0, react_1.useState)(null), selectindex = _c[0], SetSelectIndex = _c[1];
    var _d = (0, react_1.useState)([]), itemlist = _d[0], SetItemList = _d[1];
    var location = (0, react_router_dom_1.useLocation)();
    /** 获取配置 */
    var getConfig = function () { return __awaiter(_this, void 0, void 0, function () {
        var config;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, sidemenu_1.getSidemenuData)()];
                case 1:
                    config = _a.sent();
                    SetConfig(config.sidemenu);
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        getConfig();
    }, []);
    (0, react_1.useEffect)(function () {
        if (config) {
            var pathway = findPath(config, location.pathname.replace('/center/', '/').replace('/center2/', '/'), location.hash);
            // console.info(pathway)
            if (pathway.length > 1) {
                SetItemList(config[pathway[0]].sub[pathway[1]].sub);
            }
            if (pathway.length > 2) {
                SetSelectIndex(pathway[2]);
            }
        }
    }, [config, location]);
    if (config == null)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement("div", { className: (_a = props.class) !== null && _a !== void 0 ? _a : "maintab3" },
        react_1.default.createElement("ul", { className: "scf" }, itemlist.map(function (v, index) {
            return react_1.default.createElement(react_1.default.Fragment, { key: index }, v.path ?
                react_1.default.createElement("li", { className: selectindex == index ? 'active' : '' },
                    react_1.default.createElement(react_router_dom_1.Link, { to: '/' + window.mainpath + (v.path.indexOf('#') == 0 ? inner_pathname : '') + v.path }, v.title))
                :
                    react_1.default.createElement("li", null,
                        react_1.default.createElement("a", { href: v.link }, v.title)));
        }))));
}
exports.MainTab3 = MainTab3;
/** 查找菜单路径 */
function findPath(config, pathname, hash) {
    var path = pathname + hash;
    var result = [];
    config.forEach(function (v, index) {
        // console.info(v.path)
        var vpath = v.path;
        if (v.path && v.path.indexOf('#') == 0) {
            vpath = '/gridlist.html' + v.path;
        }
        if (vpath == path) {
            result.push(index);
        }
        if (v.sub) {
            var findsub = findPath(v.sub, pathname, hash);
            if (findsub.length > 0) {
                if (result.length == 0) {
                    result = result.concat(index).concat(findsub);
                }
                else {
                    result = result.concat(findsub);
                }
            }
        }
    });
    return result;
}
/**
 * 自定义二级菜单
 * @param props
 * @returns
 */
function CustomMainTab2(props) {
    var _a = (0, react_1.useState)(0), selectindex = _a[0], SetSelectIndex = _a[1];
    if (props.itemlist.length < 1)
        return react_1.default.createElement(react_1.default.Fragment, null);
    var style = {};
    if (props.mt != undefined && props.mt > 0) {
        style.marginTop = props.mt + 'px';
    }
    return (react_1.default.createElement("div", { className: "maintab", style: style },
        react_1.default.createElement("ul", { className: "scf" }, props.itemlist.map(function (v, index) {
            return react_1.default.createElement(react_1.default.Fragment, { key: index },
                react_1.default.createElement("li", { className: index == selectindex ? 'active' : '', onClick: function (e) { e.preventDefault(); SetSelectIndex(index); } },
                    v.path && react_1.default.createElement(react_router_dom_1.Link, { to: (v.path.indexOf('#') == 0 ? inner_pathname : '') + v.path }, v.title),
                    v.link && react_1.default.createElement("a", { href: v.link }, v.title),
                    !v.path && !v.link && react_1.default.createElement("span", null, v.title)));
        }))));
}
exports.CustomMainTab2 = CustomMainTab2;
